<template>
	<div class="managers-list">
		<div class="grid grid-cols-4 gap-4">
			<div class="col-start-1 col-end-2">
				<RouterLink to="/manager/duty-schedule">
					<vs-button color="primary" type="filled">{{ $t('managerDutySchedule') }}</vs-button>
				</RouterLink>
			</div>
			<div class="col-start-2 col-end-6 flex">
				<div class="w-1/3 mr-2">
					<vx-input-group>
						<div
							class="vs-component vs-con-input-label vs-input vs-input-primary"
						>
							<div class="vs-con-input"></div>
							<vs-datepicker
								v-model="off"
								format="dd.MM.yyyy"
								:placeholder="$t('exchange.off')"
								name="date_off"
							></vs-datepicker>
						</div>
					</vx-input-group>
				</div>
				<div class="w-1/3 mr-2">
					<vx-input-group>
						<div
							class="vs-component vs-con-input-label vs-input vs-input-primary"
						>
							<div class="vs-con-input"></div>
							<vs-datepicker
								v-model="to"
								format="dd.MM.yyyy"
								:placeholder="$t('exchange.to')"
								name="date_to"
							></vs-datepicker>
						</div>
					</vx-input-group>
				</div>
				<div class="w-1/3">
					<vs-custom-button
						type="border"
						@click="calculateSalary"
						class="logo-block__btn w-full pl-1 pr-1"
					>
						{{ $t('calculateSalary') }}
					</vs-custom-button>
				</div>
			</div>
			<div class="col-end-8 col-span-2">
				<RouterLink to="/manager/create">
					<vs-button color="success" type="filled">{{ $t('add') }}</vs-button>
				</RouterLink>
			</div>
		</div>
		<vx-card class="my-8">
			<div class="perPage">
				<v-select
					class="selectExample"
				  	v-model="select1"
				  	:searchable="false"
				  	:options="[10,20,50]"
				/>
			</div>
			<div class="tab-text ">
				<vs-table :max-items="select1" pagination :data="works">
					<template slot="thead">
						<vs-th v-for="fil in field" :style="'width:' +fil.width" :class="{'justify-center': fil.align && fil.align === 'center'}">
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr class="vs-table-filters">
							<template v-for="fil in field">
								<vs-td v-if="fil.field === 'manager'" >
									<vs-input class="w-full" v-model="searchName" @input="filterTable"></vs-input>
								</vs-td>
<!--								<vs-td v-else-if="fil.field === 'username'">-->
<!--									<vs-input class="w-full" v-model="searchUsername" @input="filterTable"></vs-input>-->
<!--								</vs-td>-->
								<vs-td v-else-if="fil.field === 'email_payment'">
									<vs-input class="w-full" v-model="searchEmailPayment" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'name'">
									<vs-input class="w-full" v-model="searchName" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'email'">
									<vs-input class="w-full" v-model="searchEmail" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'phone'">
									<vs-input class="w-full" v-model="searchPhone" @input="filterTable"></vs-input>
								</vs-td>
								<vs-td v-else-if="fil.field === 'gender'">
									<v-select
										v-model="searchGender"
										@input="filterTable"
										:options="genders"
										:reduce="country => country.id"
										label="name"
										class="single-row-select"
									/>
								</vs-td>
								<vs-td v-else-if="fil.field === 'quality_level'">
									<v-select
										v-model="searchLevels"
										@input="filterTable"
										:options="levels"
										:reduce="country => country.id"
										label="name"
										class="single-row-select"
									/>
								</vs-td>
								<vs-td v-else-if="fil.field === 'country'">
									<v-select
										v-model="searchCountry"
										@input="filterTable"
										:options="countries"
										:reduce="country => country.id"
										label="name"
										class="single-row-select"
									/>
								</vs-td>
								<vs-td v-else></vs-td>
							</template>
						</vs-tr>
						<vs-tr :key="indextr"  v-for="(tr, indextr) in data">
							<template v-for="fil in field">
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-if="fil.field === 'name'" >
									<router-link :to="'manager/' + tr.id">
										{{ tr.first_name }} {{tr.last_name}}
									</router-link>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" 
										class="text-sm"
										v-else-if="fil.field === 'onlineStatus'"
								>
									<div v-if="tr.onlineStatus == 1" class="fsrOnlineM">
										<router-link :to="'manager/' + tr.id">
											{{ $t('online') }}
										</router-link>
									</div>
									<div v-if="tr.onlineStatus == 0" class="fsrOfflineM">
										<router-link :to="'manager/' + tr.id">
											{{ $t('offline') }}
										</router-link>
									</div>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'manager.username'">
									<!--											<router-link :to="'manager/' + deepFind(tr, 'manager.id')">-->
									<router-link to="/">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'manager.username'">
									<router-link v-if="tr[fil.field]" :to="'manager/' + deepFind(tr, 'manager.id')">
										{{ deepFind(tr, fil.field) }}
									</router-link>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'manager'">
									<div class="user-info">
										<div class="user-info__photo">
											<img :src="tr.photo" alt="">
										</div>
										<router-link class="user-info__block"  :to="'manager/' + tr.id">
											<div class="user-info__name">{{ tr.first_name }}</div>
											<div class="user-info__surname">{{ tr.last_name }}</div>
										</router-link>
									</div>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'chat_messages_count'">
									<span
										class="counter"
										:class="{ warn: tr.is_chat_unread }"
									>
										{{ tr.chat_messages_count }}
									</span>
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'subject'">
									{{
										$getDeep(tr.subject, subjects)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'work_type'">
									{{
										$getDeep(tr.work_type, works)
									}}
								</vs-td>

								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'gender'">
									{{
										$getDeep(tr.gender, genders)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'country'">
									{{
										$getDeep(tr.country, countries)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'quality_level'">
									{{
										$getDeep(tr.quality_level, levels)
									}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'task'">
									<span class="task" v-if="tr[fil.field]">{{tr[fil.field].date_time | moment('DD.MM.YYYY')}}</span>
									<span class="task" @click="idOrder = tr.id;activePrompt = true" v-else>+</span>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'price'">
									{{ tr[fil.field] }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'generalManager'">
									<vs-checkbox
										v-if="tr[fil.field] === false"
										v-model="tr[fil.field]"
										class="w-full"
										@change="appointGeneralManager(tr)"
									>
									</vs-checkbox>
									<vs-checkbox
										v-if="tr[fil.field] === true"
										v-model="tr[fil.field]"
										class="w-full"
										:disabled="true"
									>
									</vs-checkbox>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'balance'">
									{{ tr[fil.field] }}&nbsp;&#8364;
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'is_enabled_for_junior'">
									{{ tr[fil.field] ? $t('yes') : $t('no') }}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="fil.field === 'actions'">
									<div class="flex justify-center">
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="loginAs(tr)"
											icon="edit"
										>
											<feather-icon icon="LogInIcon"></feather-icon>
										</vs-button>
										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click="$router.push('/manager/'+tr.id+'/edit')"
											icon="edit"
										>
											<feather-icon icon="EditIcon"></feather-icon>
										</vs-button>

										<vs-button
											size="small"
											color="#626262"
											type="flat"
											icon-pack="feather"
											@click='editModel = tr;$vs.dialog({
												color: "danger",
												title: $t("confirmDeletion"),
												acceptText: $t("delete"),
												cancelText: $t("cancel"),
												text: $t("doYouWantToDelete") + " \"" + tr.first_name + " " + tr.last_name + "\"",
												accept: removeTask,
											});'
											icon="edit"
										>
											<feather-icon icon="Trash2Icon"></feather-icon>
										</vs-button>
									</div>
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else-if="tr[fil.field]">
									{{tr[fil.field]}}
								</vs-td>
								<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
									...
								</vs-td>
							</template>

						</vs-tr>
					</template>
				</vs-table>
			</div>
		</vx-card>
		<vs-prompt
			@cancel="date = ''"
			@accept="addAuthor"
			:active.sync="activePrompt"
			:title="$t('registrationLinkCreation')"
			:acceptText="$t('create')"
			:cancelText="$t('cancel')"
			color="success"
		>
			<div class="flex items-end">
				<vs-input :label="$t('linkToRegistrationForm')" ref="mylink" class="w-full mr-3"
						  placeholder="Placeholder" v-model="linkAuthor"/>
				<vs-button
					size="small"
					icon-pack="feather"
					@click="copyURL"
					icon="edit"
				>
					<feather-icon icon="CopyIcon"></feather-icon>
				</vs-button>
			</div>
		</vs-prompt>
	</div>
</template>

<script>
    import Datepicker from "vuejs-datepicker";
	import vSelect from 'vue-select'
	import notifier from "@/mixins/notifier";
    import databaseManager from "@/mixins/databaseManager";

	import debounce from 'debounce'
	export default {
		name: "typeWorks",
		mixins: [notifier, databaseManager],
		components: {
			'v-select': vSelect,
			Datepicker,
		},
		data() {
			return {
				searchName: '',
				searchEmail: '',
				searchEmailPayment: '',
				searchUsername: '',
				searchPhone: '',
				searchGender: null,
				searchCountry: null,
				searchLevels: null,

				off: "",
                to: "",

				select1: 10,
				nameRu: '',
				nameDe: '',
				price: '',
				juniorIs: false,

				countries: [],
				genders: [],
				activePrompt: false,
				activePromptEdit: false,
				popupActiv: false,
				subjects: [],
				levels: [],
				works: [],
				editModel: {},
				linkAuthor: '',

				checkTrue: true,
			};
		},
		methods: {
			appointGeneralManager(manager) {
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('changeGeneralManagerTitle'),
                    text: this.$t('doYouWantChangeGeneralManager') + manager.last_name + ' ' + manager.first_name + '?',
                    accept: this.changeFinishGeneralManager,
                    parameters: [manager],
					cancel: () => (manager.generalManager = !manager.generalManager),
                    acceptText: this.$t('confirm'),
                    cancelText: this.$t('cancel')
                });
            },
			changeFinishGeneralManager: async function(parameters) {
                try {
                    await this.dbChangeFinishGeneralManager(parameters[0].id);
                    this.notifySuccess(this.$t("changedSuccessfully"));
                } catch (e) {
                    this.notifyError(this.$t('errorNotification'));
                }

				this.getWorks();
            },
			async loginAs(client) {
				try {
					const url = `/admin/manager/get-token?email=${client.email}`;
					const res = (await this.$http.get(url)).data.data;
					window.open(`/token/${res.role}/${res.token}`);

				} catch(e) {
					this.notifyError(e.message);
				}
			},
			async loginAuthor(tr){
				let route = '/manager/auth/login-as/'+tr.id
				this.$store.dispatch('login', {payload: {},route})
					.then(() => {
						this.$vs.loading.close()
						this.$router.push('/');
					})
					.catch(error => {
						this.$vs.loading.close()
						this.notifyError(error.message);
					});
			},
			copyURL() {
				var Url = this.$refs.mylink
				Url.$el.querySelector('.vs-inputx').select();
				document.execCommand("copy");
			},
			addAuthor(){

			},
			filterTable:  debounce(function (e) {
				let options = '?';
				if(this.searchName.length > 0) options += 'filter[name]='+this.searchName+'&'
				if(this.searchUsername.length > 0) options += 'filter[username]='+this.searchUsername+'&'
				if(this.searchEmail.length > 0) options += 'filter[email]='+this.searchEmail+'&'
				if(this.searchEmailPayment.length > 0) options += 'filter[email_payment]='+this.searchEmailPayment+'&'
				if(this.searchGender !== null) options += 'filter[gender]='+this.searchGender+'&'
				if(this.searchLevels !== null) options += 'filter[quality_level]='+this.searchLevels+'&'
				if(this.searchCountry !== null) options += 'filter[country]='+this.searchCountry+'&'
				if(this.searchPhone.length > 0) options += 'filter[phone]='+this.searchPhone
				this.getWorks(options);
			}, 500),
			async removeTask(){
				try {
					await this.$http.post("/admin/manager/delete/"+this.editModel.id);

					this.notifySuccess(this.$t('deletedSuccessfully'));
					this.editModel = {};
					this.getWorks();

				} catch (e) {
					this.notifyError(e.message);
				}
			},
			async editTask(id) {
				try {
					let validator = await this.$validator.validateAll();
					if(!validator) return this.activePromptEdit = true;
					let formData = {
						"name_ru": this.editModel.name_ru,
						"name_de": this.editModel.name_de,
						"price": this.editModel.price,
						"is_enabled_for_junior": this.editModel.is_enabled_for_junior
					}

					await this.$http.post("/admin/manager/update/"+this.editModel.id,formData);

					this.notifySuccess(this.$t('changedSuccessfully'));
					this.editModel = {};
					this.activePromptEdit = false;
					this.getWorks();

				} catch (e) {
					this.notifyError(e.message);
				}
			},
			async calculateSalary() {
				try {
					let options = {
						off: this.off,
						to: this.to,
					};

					let urlFile = await this.dbGetCalculateSalaryManagers(options);

					window.open(urlFile.url, '_blank');
					// console.log(urlFile);

				} catch (e) {
					this.notifyError(e.message);
				}
			},
			async createTask(id) {
				try {
					let validator = await this.$validator.validateAll();

					if(!validator) return this.activePrompt = true;
					let formData = {
						"name_ru": this.nameRu,
						"name_de": this.nameDe,
						"price": this.price,
						"is_enabled_for_junior": this.juniorIs
					}

					await this.$http.post("/admin/manager/create",formData);

					this.notifySuccess(this.$t('addedSuccessfully'));
					this.nameRu = "";
					this.nameDe = "";
					this.price = "";
					this.juniorIs = false;
					this.popupActiv = false;

					this.getWorks();

				} catch (e) {
					this.notifyError(e.message);
				}
			},
			deepFind(obj, path) {
				if (!path) return "";
				let paths = path.split("."),
					current = obj,
					i;

				for (i = 0; i < paths.length; ++i) {
					if (current[paths[i]] === undefined) {
						return undefined;
					} else {
						current = current[paths[i]];
					}
				}
				return current;
			},
			async getWorks(options) {
				try {
					let url = options ? "/admin/manager" + options : "/admin/manager";
					const res = (await this.$http.get(url)).data.data;
					this.works = res || [];
				} catch (e) {
					this.$vs.notify({
						title: "Error",
						text: e.message,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
					});
				}
			},
		},
		created() {
			this.field = [
				{
					field: "generalManager",
					title: this.$t('topManager'),
					align: 'center',
					width: '5%'
				},
				{
					field: "manager",
					title: this.$t('manager'),
					align: 'center',
					width: '15%'
				},
				{
					field: "type",
					title: this.$t('managerType'),
					align: 'center',
					width: '10%'
				},
				// {
				// 	field: "balance",
				// 	title: this.$t('balance'),
				// 	align: 'center',
				// 	width: '10%'
				// },
				{
					field: "onlineStatus",
					title: this.$t('onlineStatusManager'),
					align: 'center',
					width: '10%'
				},
				{
					field: "email",
					title: "Email",
					align: 'center',
					width: '20%'
				},
				{
					field: "phone",
					title: this.$t('phone'),
					align: 'center',
					width: '15%'
				},
				// {
				// 	field: "gender",
				// 	title: this.$t('sex'),
				// 	align: 'center',
				// 	width: '11.25%'
				// },
				// {
				// 	field: "country",
				// 	title: this.$t('country'),
				// 	align: 'center',
				// 	width: '10%'
				// },
				{
					field: "actions",
					title: this.$t("actions"),
					align: 'center',
					width: '5%'
				},
			];
		},
		async mounted() {
			this.getWorks();

			this.levels = (
				await this.$http.get("/settings/get-quality-levels")
			).data.data;
			this.genders = (
				await this.$http.get("/settings/get-genders")
			).data.data;
			this.countries = (
				await this.$http.get("/settings/get-countries")
			).data.data;
		},
	};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}
	.vs-popup--content {
		padding: 0;
	}
	table {
		width: 100%;
		td {
			padding-bottom: 4px;
		}
	}
	.body {
		padding: 1rem;
		table {
			margin-left: -2px;
		}
		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}
	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;
		button {
			margin-left: 10px;
		}
	}
}

.managers-list {
	.buttons {
		justify-content: flex-end;
	}
	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.user-info {
		display: flex;
		justify-content: flex-start;
		align-items: center;

		&__photo{
			display: flex;
			justify-content: center;
			align-items: center;
			flex: 30px 0 0;
			width: 30px;
			height: 30px;
			overflow: hidden;
			border-radius: 100%;
			margin-right: 10px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		&__block {
			display: flex;
			justify-content: center;
		}

		&__surname {
			margin-left: 7px;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}
	.vs-con-table .vs-con-tbody,.vs-table--content{
		overflow: visible;
	}
	.perPage{
		max-width:  80px;
		.vs__dropdown-toggle{
			border-radius: 100px;
		}
		.vs__clear{
			display: none;
		}
		.v-select__selection {
			width: 100%;
			justify-content: center;
		}
	}
	.inputInTable {
		border: 0;
		resize: none;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}
	.justify-center .vs-table-text{
		justify-content: center;
	}
	.vs-checkbox-default{
		flex-shrink: 0;
	}
	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}
	.con-exemple-prompt {
		.append-text {
			height: 2.7rem;
		}
		.vs-button {
			border-left: 0;
		}
		.vx-input-group-append {
			align-items: flex-end;
		}
		.vs-input {
			width: 100%;
			textarea {
				resize: none;
			}
		}
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}
	.con-vs-tabs .con-slot-tabs{
		overflow: visible;
	}
	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}
	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.date {
			display: flex;
			align-items: center;
		}
		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}
		.vx-input-group {
			margin-right: 20px;
		}
		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}
		.search .vs-con-input-label {
			width: 270px;
		}
	}
}
</style>
